module.exports = __webpack_public_path__ + "static/books-1792ee7f003c3c88c2f5df4e14202884.jpg";